import './App.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Pages/Home';
import Summary from './Pages/Summary';
import Terms from './Pages/Terms';
import Thanks from './Pages/Thanks';
import Privacy from './Pages/Privacy';
import ShippingPolicy from './Pages/ShippingPOlicy';


function App() {
  return (
    <Router basename="/">
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path='/summary' element={<Summary />} />
      <Route path='/terms' element={<Terms />} />
      <Route path='/privacy' element={<Privacy />} />
      <Route path='/thanks' element={<Thanks />} />
      <Route path='/shippingpolicy' element={<ShippingPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
